import { FlosIcon, Link } from '@flos/react-ui';
import { useState } from 'react';
import { isLongtermPrivateLob } from '../../../utils/externalCasesUtil';
import RemoveModal from '../../../shared_components/RemoveModal/RemoveModal';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useHippoText } from '../../../hooks/useHippoText';
import { isOnsaCoverable } from '../utils/ShoppingBasketUtil';
import { useRecoilValue } from 'recoil';
import { onsaProductStatusListAtom } from '../../../recoil/atoms/onsaProductStatusListAtom';
import CallMeModal from '../../../shared_components/CallMeModal/CallMeModal';

const ShoppingBasketRemoveCoverable = ({
    coverable,
    displayOverlayText = false
}: {
    coverable: CoverableDTO;
    displayOverlayText?: boolean;
}): React.JSX.Element => {
    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [showCallMeModal, setShowCallMeModal] = useState(false);
    const getHippoText = useHippoText();
    const productStatusList = useRecoilValue(onsaProductStatusListAtom);
    const displayModal = (): void => {
        setShowRemoveModal(true);
    };

    const isCoverableRemovable =
        isLongtermPrivateLob(coverable.lobCode ?? '') &&
        (coverable.status === 'Added' || isOnsaCoverable(coverable, productStatusList)) &&
        coverable.status !== 'Changed';
    return isCoverableRemovable ? (
        <div className="u-flex-box u-gap-2">
            <FlosIcon
                className="is-indigo"
                shape={'trash-can'}
                size={'xsmall'}
                onClick={() => {
                    displayModal();
                }}
            />
            <Link
                className="u-Normalwrap u-color-primary-1-base u-spacing-stack-none paragraph--small"
                onClick={() => {
                    displayModal();
                }}
            >
                {displayOverlayText
                    ? getHippoText('DSS-COMMON-REMOVE')
                    : getHippoText('DSS-SHOPPING-BASKET-UNDO')}
            </Link>
            <div className="u-spacing-inset-none">
                {showRemoveModal && (
                    <RemoveModal
                        coverable={coverable}
                        showModal={showRemoveModal}
                        closeModal={() => {
                            setShowRemoveModal(false);
                        }}
                    />
                )}

                {showCallMeModal && (
                    <CallMeModal
                        activityCode="dss_call_request"
                        title={getHippoText('DSS-CALL-ME-MODAL-UNDO-CHANGES-HEADER')}
                        description={getHippoText('DSS-CALL-ME-MODAL-UNDO-CHANGES-SUBHEADER')}
                        showModal={showCallMeModal}
                        closeModal={() => {
                            setShowCallMeModal(false);
                        }}
                    />
                )}
            </div>
        </div>
    ) : (
        <></>
    );
};

export default ShoppingBasketRemoveCoverable;
